
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import getFreshSideObject from './getFreshSideObject.js';

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

export { mergePaddingObject as default };
//# sourceMappingURL=mergePaddingObject.js.map
